import React from 'react'

const ArrowDownBlack = () => {
  return (
    <svg width='13' height='8' viewBox='0 0 13 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M6.81978 0.88627L6.81983 0.886316L12.1242 6.47541L12.1245 6.47572C12.2918 6.6527 12.2918 6.93433 12.1245 7.11131L12.1241 7.11166C11.952 7.29296 11.6577 7.29437 11.4849 7.1113C11.4848 7.11114 11.4846 7.11098 11.4845 7.11082L6.49987 1.85926L1.51549 7.11163L1.51549 7.11163L1.51464 7.11253C1.43285 7.19786 1.31895 7.25 1.19551 7.25C1.07207 7.25 0.958164 7.19786 0.876384 7.11253L0.876376 7.11254L0.874852 7.11092C0.708275 6.934 0.708247 6.65267 0.875583 6.47574L0.875878 6.47543L6.17987 0.886699L6.18066 0.885874C6.3529 0.706045 6.64599 0.703243 6.81978 0.88627Z'
        fill='#000'
        stroke='#000'
        strokeWidth='0.5'
      />
    </svg>
  )
}

export default ArrowDownBlack
